import { Fragment, useState } from "react";
import style from "./index.module.css";
import { header_comp } from "./table_innerComponents/TableComponent";
import { useMemo } from "react";
import Pagination from "components/Pagination";

const Table = (props) => {
  const { data = header_comp, page, total, changeCurrentPage, currentPage } = props;
  const numbers = data.body.length;
  const count = numbers;


  function test(type) {
    const config = {
      header: {
        string: (content) => <th>{content}</th>,
        image: (content) => <th>{content}</th>,
        html: (content) => <th>{content}</th>,
      },
      body: {
        string: (content) => <td>{content}</td>,
        html: (content) => <td>{content}</td>,
        image: (content) => <img alt="content" src={content} />,
        number: (content) => <th>{content}</th>,
      },
    };

    return config[type];
  }

  const render = (tableType, { content, type = "string" }) => {
    let a = test(tableType);
    return a[type](content);
  };

  return (
    <div className={style.tabel_wrapper}>
      <div className={style.table_scroll}>
        <table className={`${style.table} table_long`}>
          <thead>
            <tr>
              {data.header.map((item) => {
                return (
                  <Fragment key={item.content}>
                    {render("header", item)}
                  </Fragment>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.body.map((item, index) => {
              return (
                <tr key={index}>
                  {item?.map((item, _index) => {
                    return (
                      <Fragment key={index + _index}>
                        {render("body", item)}
                      </Fragment>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className={style.table_footer}>
        <Pagination
          maxCount={total}
          itemsPerPage={page}
          currentPage={currentPage}
          setCurrentPage={changeCurrentPage}
        />
      </div>
    </div>
  );
};

export default Table;
